// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--iEu0p","icon":"_02712f2b3b--icon--uMaQc"};